import React, { useEffect, useState } from "react";
import "../pages/Home.scss";
import axios from "axios";
import WidgetCollection from "../components/widget-collection/WidgetCollection";
function App() {
    const [category, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [productsUrl, setProductsUrl] = useState("");
    useEffect(() => {
        fetchData();
    }, []);
    async function fetchData() {
        const p1 = axios.post("https://endpoint.retailtune.com/endpoint/v1/estore/categories-structure/by-lang", {
            key: "6bt63AGksDV4qTGgUcqkRS91KVlkV2dsSJ9qCN6YNjCLiq7slAJikEb1QvRNdCEnzZrzAzPz96PMTwzCwHRkK03gSSCN1IgNjYBN",
            query: {
                store_id: window.storeID,
                lang: window.lingua,
                hide_unavailable: false,
                store_area: true,
            },
        });
        const p2 = axios.get("https://negozi.saporedimare.it/concierge-to-pdp/" + window.storeID + "-" + window.linguaID + ".json");
        const [categoryRes, productUrls] = await Promise.all([p1, p2]);
        console.log(categoryRes.data.response);
        const dataCategories = categoryRes.data.response.lines;
        setCategories(dataCategories);
        setProductsUrl(productUrls.data.pdp_url);
    }
    const fetchProduct = (line, macrocategory, category) => {
        console.log("Chiamata di rete prodotti");
        axios
            .post("https://endpoint.retailtune.com/endpoint/v1/product-skus-info/by-lang", {
            key: "6bt63AGksDV4qTGgUcqkRS91KVlkV2dsSJ9qCN6YNjCLiq7slAJikEb1QvRNdCEnzZrzAzPz96PMTwzCwHRkK03gSSCN1IgNjYBNQ",
            query: {
                store_id: window.storeID,
                lang: window.lingua,
                line_label: line,
                macro_category_label: macrocategory,
                category_label: category,
                hide_unavailable: false,
                store_area: true,
            },
        })
            .then(res => {
            console.log(res.data.response);
            if (res.data.result === "error")
                throw res.data.error;
            setProducts(res.data.response);
        })
            .catch(e => console.error(e));
    };
    return (React.createElement("div", { className: "filteredList" },
        category.length > 0 && React.createElement("h3", { className: "title-sect" }, window.titleCatalog),
        React.createElement(WidgetCollection, { data: category, showThumb: false, productUrl: productsUrl, products: products, getProduct: fetchProduct, setProduct: setProducts })));
}
export default App;
